import { getReportReviewSheetTemplate } from '../helper/get-report-review-sheet-template';
import { allReportReasons } from '../helper/report-reasons';
import { Sheet } from '@otto-ec/global-pattern';
import { trackEvent } from '../../../_common/client/tracking';
import { CustomerReviewBackendRequester } from './customer-review-backend-requester';
import { SnackbarService } from '../../../_common/client/snackbar-service';

export class ReportReviewSheetService {
    private readonly successSnackbarText: string =
        'Vielen Dank für deine Hilfe!\nEin Mitarbeiter wird die von dir gemeldete Kundenbewertung schnellstmöglich prüfen.';

    constructor(
        private customerReviewBackendRequester: CustomerReviewBackendRequester,
        private snackbarService: SnackbarService
    ) {}

    public openSheet(reviewId: string, reviewPosition: number): void {
        const sheet = new o_global.pali.sheetBuilder({
            title: 'Kundenbewertung melden',
            content: getReportReviewSheetTemplate(allReportReasons),
        });

        sheet.open();

        this.registerOnSubmitButtonClick(sheet, () => this.reportReview(sheet, reviewId, reviewPosition));
        this.registerOnRadioButtonChange(sheet, () => this.hideSheetErrorMessage(sheet));
    }

    private registerOnSubmitButtonClick(sheet: Sheet, onSubmitButtonClick: () => void) {
        this.getSubmitButton(sheet)?.addEventListener('click', onSubmitButtonClick);
    }

    private registerOnRadioButtonChange(sheet: Sheet, onChange: () => void) {
        window.o_util.event.delegate(sheet.getContent(), 'change', '.js_pdp_cr_report-review-list__radio', onChange);
    }

    private reportReview(sheet: Sheet, reviewId: string, reviewPosition: number) {
        const selectedReportReason = this.getSelectedReportReason(sheet);

        if (!selectedReportReason) {
            this.makeErrorMessageVisible(sheet);
            return;
        }

        this.trackSubmitAction(selectedReportReason, reviewPosition);
        this.customerReviewBackendRequester.reportReview(reviewId, selectedReportReason);
        sheet.close();
        this.snackbarService.showSnackbar(this.successSnackbarText);
    }

    private hideSheetErrorMessage(sheet: Sheet): void {
        const selectedRadioButton = sheet?.getContent().querySelector('.js_pdp_cr_report-review-list__radio:checked');
        if (selectedRadioButton) {
            sheet.getContent().querySelector('.js_pdp_cr_report-review-sheet__error')?.classList.add('pl_hidden');
        }
    }

    private trackSubmitAction(selectedReportReason: string, reviewPosition: number) {
        trackEvent({
            review_ReportReview: 'send',
            review_SingleReviewPosition: reviewPosition,
            review_SingleReviewReason: selectedReportReason,
        });
    }

    private makeErrorMessageVisible(sheet: Sheet) {
        sheet.getContent().querySelector('.js_pdp_cr_report-review-sheet__error')?.classList.remove('pl_hidden');
    }

    private getSelectedReportReason(sheet: Sheet) {
        return sheet.getContent().querySelector<HTMLInputElement>('.js_pdp_cr_report-review-list__radio:checked')?.value;
    }

    private getSubmitButton(sheet: Sheet) {
        return sheet.getContent().querySelector<HTMLElement>('.js_pdp_cr_report-review-sheet__submit');
    }
}
